import { render, staticRenderFns } from "./BusinessSubController.vue?vue&type=template&id=a606db0c&scoped=true&"
import script from "./BusinessSubController.vue?vue&type=script&lang=js&"
export * from "./BusinessSubController.vue?vue&type=script&lang=js&"
import style0 from "./BusinessSubController.vue?vue&type=style&index=0&id=a606db0c&scoped=true&lang=scss&rel=stylesheet%2Fscss&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a606db0c",
  null
  
)

export default component.exports